import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiGetHardenerDetail(id: number): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/hardener/${id}`);
}

export function apiGetAllHardeners(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/hardeners`);
}

export function apiCreateOrUpdateHardener(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/hardenercreateorupdate`, data);
}

export function apiDeleteHardener(id: number): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/hardener/${id}`);
}
